/**
 * Web Style Import
 *
 */

import './style/dnb-typography.scss'
